import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIResponse } from 'src/app/core/models/api-response';
import { IBrand } from '../models/brands.models';
import { environment } from 'src/environments/environment';
import { ITag } from '../models/tags.models';
import { ICatalog } from 'src/app/features/catalogs/models/catalogs.models';
import { ICategory } from '../models/catagories.models';
import { IObjectCustomFields, IObjectCustomFieldsParams } from '../models/custom-fields.models';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private http: HttpClient) {}

  public listAllBrands(): Observable<APIResponse<IBrand>> {
    return this.http.get<APIResponse<IBrand>>(environment.BASE_URL_API + 'brands');
  }

  public listAllTags(): Observable<APIResponse<ITag>> {
    return this.http.get<APIResponse<ITag>>(environment.BASE_URL_API + 'tags');
  }

  public listAllCategories(): Observable<APIResponse<ICategory>> {
    return this.http.get<APIResponse<ICategory>>(environment.BASE_URL_API + 'categories');
  }

   // Get Object Custom Fields
   public getObjectCustomFields(params: IObjectCustomFieldsParams): Observable<APIResponse<IObjectCustomFields>> {
    return this.http.get<APIResponse<IObjectCustomFields>>(environment.BASE_URL_API + 'custom-fields/values/' + params.object_type + '/' + params.record_id + '?visibility=' + params.visibility?.join(',') + '&include_definitions=' + params.include_definitions?.toString() || 'false');
  }

  // Update Object Custom Fields values (keyed by technical_name)
  public updateObjectCustomFields(params: IObjectCustomFieldsParams, values: IObjectCustomFields['values']): Observable<APIResponse<IObjectCustomFields>> {
    return this.http.put<APIResponse<IObjectCustomFields>>(
      environment.BASE_URL_API + 'custom-fields/values/' + params.object_type + '/' + params.record_id,
      { values }
    );
  }
}
